import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Divider,
  Form,
  Input,
  Select,
  Table,
  Typography,
  notification,
} from "antd";
import moment from "moment";

import { getOnlyTrue as getAllCountries } from "../../api/modules/countries";
import {
  getAllByUser as getAllAnswers,
  post,
} from "../../api/modules/globalRegionalAnswers";
import INTERNAL_LINKS from "../../enum/InternalLinks";

const { Title } = Typography;

const GlobalRegionalSurveyHomePage = () => {
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Country / País",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "City / Ciudad",
      dataIndex: "q1_b",
      key: "q1_b",
    },
    {
      title: "Date / Fecha",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => {
        return moment(text).format("YYYY-MM-DD HH:mm");
      },
    },
    {
      title: "Actor",
      dataIndex: "q1_c",
      key: "q1_c",
    },
    {
      title: "Status / Estado",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        if (
          record.status_i === 2 &&
          record.status_iii === 2 &&
          record.status_iv === 2
        ) {
          return "Finished / Terminada";
        } else {
          return "In progress / En proceso";
        }
      },
    },
    {
      title: "Actions / Acciones",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => {
        return (
          <>
            <Button style={{ width: "100%" }} type="primary">
              <Link
                to={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_HOME}/${record.id}`}
              >
                Edit / Editar
              </Link>
            </Button>
          </>
        );
      },
    },
  ];
  const [answersData, setAnswersData] = useState([]);
  const [countriesData, setCountriesData] = useState([]);
  const [createForm] = Form.useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    await Promise.all([getCountries(), getAnswers()]);
  };

  const getAnswers = async () => {
    setTableLoading(true);
    const response = await getAllAnswers();
    setAnswersData(response.data.results);
    setTableLoading(false);
  };

  const getCountries = async () => {
    const response = await getAllCountries();
    setCountriesData(response.data.results);
  };

  const createAnswer = async (data) => {
    setCreateLoading(true);
    try {
      await post(data);
      createForm.resetFields();
      setCreateLoading(false);
      getAnswers();
      notification.open({
        message: "Successful transaction / Transacción exitosa ",
        duration: 2,
        placement: "bottomRight",
      });
    } catch (err) {
      console.log(err);
      setCreateLoading(false);
    }
  };

  return (
    <div>
      <Title level={3}>Global/Regional Surveys / Global/Regional Entrevistas</Title>

      <Divider>
        New elements section / Sección para crear nuevos elementos
      </Divider>
      <Form
        layout="vertical"
        form={createForm}
        onFinish={(data) => {
          createAnswer(data);
        }}
      >
        <Form.Item
          label="Country / País"
          name="q1_a"
          rules={[{ required: true }]}
        >
          <Select showSearch optionFilterProp="children">
            {countriesData.length > 0 &&
              countriesData.map((item) => (
                <Select.Option key={`country-key-${item.id}`} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="City / Ciudad"
          name="q1_b"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Name / Nombre"
          name="q1_c"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button loading={createLoading} type="primary" htmlType="submit">
            Save and continue / Guardar y continuar
          </Button>
        </Form.Item>
      </Form>
      <Divider>Existing items / Elementos existentes</Divider>
      <Table
        rowKey="id"
        loading={tableLoading}
        dataSource={answersData}
        columns={columns}
      />

      <Button type="primary">
        <Link to={INTERNAL_LINKS.HOME}>Back / Volver</Link>
      </Button>
    </div>
  );
};

export default GlobalRegionalSurveyHomePage;
